// Organisation-wide currency support. The selected currency lives on the
// company record and is surfaced on the current user as `company_currency`.
// Keep this list in sync with SUPPORTED_CURRENCIES in the backend
// profileController.

export const CURRENCIES = [
  { code: 'USD', symbol: '$', label: 'US Dollar' },
  { code: 'EUR', symbol: '€', label: 'Euro' },
  { code: 'GBP', symbol: '£', label: 'British Pound' },
  { code: 'ZAR', symbol: 'R', label: 'South African Rand' },
  { code: 'AUD', symbol: 'A$', label: 'Australian Dollar' },
  { code: 'CAD', symbol: 'C$', label: 'Canadian Dollar' },
  { code: 'NZD', symbol: 'NZ$', label: 'New Zealand Dollar' },
  { code: 'CHF', symbol: 'CHF', label: 'Swiss Franc' },
  { code: 'INR', symbol: '₹', label: 'Indian Rupee' },
  { code: 'JPY', symbol: '¥', label: 'Japanese Yen' },
  { code: 'CNY', symbol: '¥', label: 'Chinese Yuan' },
  { code: 'SGD', symbol: 'S$', label: 'Singapore Dollar' },
  { code: 'HKD', symbol: 'HK$', label: 'Hong Kong Dollar' },
  { code: 'AED', symbol: 'د.إ', label: 'UAE Dirham' },
  { code: 'SAR', symbol: '﷼', label: 'Saudi Riyal' },
  { code: 'NGN', symbol: '₦', label: 'Nigerian Naira' },
  { code: 'KES', symbol: 'KSh', label: 'Kenyan Shilling' },
  { code: 'GHS', symbol: 'GH₵', label: 'Ghanaian Cedi' },
  { code: 'BRL', symbol: 'R$', label: 'Brazilian Real' },
  { code: 'MXN', symbol: 'Mex$', label: 'Mexican Peso' },
];

export const DEFAULT_CURRENCY = 'USD';

const CURRENCY_MAP = CURRENCIES.reduce((acc, c) => {
  acc[c.code] = c;
  return acc;
}, {});

export function getCurrencyMeta(code) {
  return CURRENCY_MAP[code] || CURRENCY_MAP[DEFAULT_CURRENCY];
}

export function getCurrencySymbol(code) {
  return getCurrencyMeta(code).symbol;
}

// Format a numeric value as currency for the given currency code.
// Falls back gracefully when the value is null/undefined/non-numeric.
export function formatCurrency(value, code = DEFAULT_CURRENCY, options = {}) {
  const num = Number(value);
  if (value === null || value === undefined || value === '' || Number.isNaN(num)) {
    return '';
  }

  const currency = getCurrencyMeta(code).code;
  try {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      ...options,
    }).format(num);
  } catch (e) {
    // Unknown currency for Intl — fall back to symbol + grouped number.
    const symbol = getCurrencySymbol(code);
    return `${symbol}${num.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      ...options,
    })}`;
  }
}
